import React from "react";
import PropTypes from "prop-types";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import styles from "components/common/modal.scss";
import Draggable from "react-draggable";

export const Modal = ({
  children,
  onClose,
  isVisible,
  transitionName
}) => {
  if (!isVisible) {
    return null;
  }
  return (
    <ReactCSSTransitionGroup
      transitionEnterTimeout={ 200 }
      transitionLeaveTimeout={ 300 }
      transitionName={ transitionName }
    >
      <button className={ styles.modal } key="modalOpen" onClick={ onClose } />
      <div className={ styles["modal-container"] } onClick={ onClose }>
        <div className={ styles["modal-box"] } onClick={ (e) => e.stopPropagation() }>
          { children }
        </div>
      </div>
    </ReactCSSTransitionGroup>
  );
};

Modal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element.isRequired,
    PropTypes.arrayOf(PropTypes.element)
  ]).isRequired,
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  transitionName: PropTypes.string.isRequired
};

export const DraggableModal = ({
  handle,
  children,
  isDisabled = false,
  isVisible
}) => {
  if (!isVisible) {
    return null;
  }
  const isDraggable = isDisabled ? "" : styles["draggable-mode"];
  return (
    <Draggable disabled={ isDisabled } handle={ handle }>
      <div className={ `${styles["draggable-modal-container"]} ${isDraggable}` }>
        { children }
      </div>
    </Draggable>
  );
};

DraggableModal.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element.isRequired,
    PropTypes.arrayOf(PropTypes.element)
  ]).isRequired,
  handle: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/common/modal.jsx